import axios from 'axios'
const sha1 = require('js-sha1');

export default {
  getLatest: (rfc) => axios.post('/rfcs/csf/latest',
    { rfc },
    { headers: { checksum: sha1(rfc || '') } }
  ),
  getPreview: (rfc, certificateId = null) => axios.post('/rfcs/csf/preview',
    certificateId ? { rfc, certificate_id: certificateId } : { rfc },
    { headers: { checksum: sha1(rfc || '') }, skipLoading: true }
  ),
  generate: (rfc) => axios.post('/rfcs/csf/generate',
    { rfc },
    { headers: { checksum: sha1(rfc || '') }, skipLoading: true }
  ),
  getDownloadLink: (rfc, certificateId = null) => axios.post('/rfcs/csf/download',
    certificateId ? { rfc, certificate_id: certificateId } : { rfc },
    { headers: { checksum: sha1(rfc || '') }, skipLoading: true }
  ),
}
